import { EventEmitter } from "eventemitter3";
import fileSys from "./fileSystem";
import { logStdout } from "../shared/utils";
const { readdirSync, statSync, existsSync, createWriteStream, createReadStream } =
  window.require("fs");
const path = window.require("path");
const { execSync } = window.require("child_process");
let writeStream, readStream;
export default class Backup extends EventEmitter {
  constructor() {
    super();
    this.count = 0;
    this.isExporting = false;
  }
  stopBackup(callback) {
    this.isExporting = false;
    try {
      if (writeStream) {
        writeStream.destroy();
      }
      if (readStream) {
        readStream.destroy();
      }
      fileSys.clearCache(() => {
        if (callback) callback();
      });
    } catch (e) {}
  }
  countFiles(dir, basedir, paths = []) {
    try {
      this.isExporting = true;
      let dirs = readdirSync(dir);
      dirs.forEach((myPath) => {
        let pt = path.join(dir, myPath);
        let st = statSync(pt);
        const reg = new RegExp(`^${basedir.replace(/\\/g, "\\\\")}`);
        if (st.isDirectory()) {
          if (this.isExporting) {
            this.countFiles(pt, basedir, paths);
          }
        } else {
          let sp = pt.replace(reg, "");
          const keyval = { subdir: path.dirname(sp), filepath: pt };
          paths.push(keyval);
        }
      });
      return paths;
    } catch (e) {
      return [];
    }
  }
  copyFileByPipe(srcs, dst) {
    if (srcs.length <= 0) {
      fileSys.syncImmediate(() => {
        this.isExporting = false;
        this.emit("finish");
      });
    } else {
      if (!this.isExporting) return;
      const src = srcs.pop();
      const { subdir, filepath } = src;
      let filename = path.basename(filepath);
      const dstSubdir = path.join(dst, subdir);
      let dstFilepath = path.join(dstSubdir, filename);
      if (!existsSync(dstSubdir)) {
        try {
          execSync(`mkdir -p ${dstSubdir}`);
        } catch (e) {
          this.emit("error", e);
        }
      }

      writeStream = createWriteStream(dstFilepath);
      readStream = createReadStream(filepath);
      writeStream.on("error", (err) => {
        this.isExporting = false;
        if (err) logStdout("copy file by pipe-writeStream", err.message || "");
        this.emit("error", err);
      });
      readStream.on("error", (err) => {
        this.isExporting = false;
        if (err) logStdout("copy file by pipe-readStream", err.message || "");
        this.emit("error", err);
      });
      writeStream.on("close", () => {
        this.count += 1;
        this.emit("process", this.count);
        if (this.isExporting) {
          this.copyFileByPipe(srcs, dst);
        }
      });
      readStream.pipe(writeStream);
    }
  }
}



// WEBPACK FOOTER //
// ./src/fileoprators/backup.js